import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4c805d7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-column" }
const _hoisted_2 = { class: "sub-row cm-ui-mb15" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "cm-ui-bold-txt" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "cm-ui-bold-txt" }
const _hoisted_8 = { class: "sub-row" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "row-column" }
const _hoisted_12 = ["data-title", "data-key"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = ["data-title", "data-key"]
const _hoisted_15 = {
  key: 0,
  style: {"padding":"20px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container cm-ui-ml10" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnTimeTitle')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.earlyWarnMonitorPeriod')
          }, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnMonitorPeriod')), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_space, {
              class: "cm-ui-mb15",
              size: 20
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnMorning')), 1),
                _createVNode(_component_el_slider, {
                  ref: "morningRangeNode",
                  class: "time-range",
                  modelValue: _ctx.morningRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.morningRange) = $event)),
                  range: "",
                  "show-stops": "",
                  marks: _ctx.marks,
                  max: 12,
                  "format-tooltip": _ctx.formatTooltip,
                  onChange: _ctx.handlerMorningRangeChange
                }, null, 8, ["modelValue", "marks", "format-tooltip", "onChange"]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnOclockRange', { a: _ctx.morningRange[0], b: _ctx.morningRange[1] })), 1)
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_el_space, { size: 20 }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnAfternoon')), 1),
                _createVNode(_component_el_slider, {
                  ref: "afternoonRangeNode",
                  class: "time-range",
                  modelValue: _ctx.afternoonRange,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.afternoonRange) = $event)),
                  range: "",
                  "show-stops": "",
                  marks: _ctx.marks,
                  min: 12,
                  max: 24,
                  "format-tooltip": _ctx.formatTooltip,
                  onChange: _ctx.handlerAfternoonRangeChange
                }, null, 8, ["modelValue", "marks", "format-tooltip", "onChange"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnOclockRange', { a: _ctx.afternoonRange[0], b: _ctx.afternoonRange[1] })), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.earlyWarnFrequency')
          }, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnFrequency')), 9, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_space, { size: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnIntervalPrefix')), 1),
                _createVNode(_component_el_select, {
                  class: "input-size",
                  size: "small",
                  modelValue: _ctx.strategy.frequency,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.frequency) = $event)),
                  modelModifiers: { number: true },
                  onChange: _ctx.setChangeStatus
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencyOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnMinuteUnit')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.t('groupPolicySettings.earlyWarnTypeTitle')), 1),
        _createVNode(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          data: _ctx.warningData,
          "header-cell-class-name": "table-hd-cell",
          "cell-class-name": "table-cell",
          border: "",
          style: {"border":"none"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: _ctx.t('groupPolicySettings.earlyWarnColType')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: _ctx.t('groupPolicySettings.earlyWarnColThreshold')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.desc.replace('#', _ctx.strategy[scope.row.valueKey])) + " ", 1),
                (scope.row.valueKey)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "btn-edit el-icon-edit",
                      "data-title": scope.row.title,
                      "data-key": scope.row.valueKey,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handlerEditSetting && _ctx.handlerEditSetting(...args)))
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                (scope.row.durationKey)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(scope.row.durationDesc.replace(
                  '#',
                  _ctx.strategy[scope.row.durationKey]
                )) + " ", 1),
                      _createElementVNode("i", {
                        class: "btn-edit el-icon-edit",
                        "data-type": "duration",
                        "data-title": scope.row.title,
                        "data-key": scope.row.durationKey,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlerEditSetting && _ctx.handlerEditSetting(...args)))
                      }, null, 8, _hoisted_14)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: _ctx.t('groupPolicySettings.earlyWarnColSwitch'),
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.strategy[scope.row.switchKey],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.strategy[scope.row.switchKey]) = $event),
                  onChange: _ctx.setChangeStatus
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data"])
      ]),
      (_ctx.operateType !== _ctx.OperateType.read)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: _ctx.handlerSave,
              disabled: !_ctx.data.hasEdit && _ctx.operateType !== _ctx.OperateType.add && 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.loading]
  ])
}